import type { AssistTurn } from "./api";

export interface Message {
  role: "you" | "assistant" | "error";
  text: string;
}

/** The text of a stored turn, whatever shape the model returned it in.
 *
 * A turn's content is a plain string for what the candidate typed and a list
 * of content blocks for what the model answered. Both are persisted, and both
 * have to be readable back: this is what lets a dropped connection recover an
 * answer that was already generated and already charged for.
 */
export function turnText(content: unknown): string {
  if (typeof content === "string") return content;
  if (Array.isArray(content)) {
    return content
      .map((block) =>
        block && typeof block === "object" && typeof (block as { text?: unknown }).text === "string"
          ? (block as { text: string }).text
          : "",
      )
      .filter(Boolean)
      .join("");
  }
  return "";
}

/** The server's record of the conversation, as the panel renders it. */
export function turnsToMessages(turns: AssistTurn[]): Message[] {
  return turns
    .map((turn) => ({
      role: turn.role === "user" ? ("you" as const) : ("assistant" as const),
      text: turnText(turn.content),
    }))
    .filter((m) => m.text.trim() !== "");
}
